import ActivateCode from './activate_code.vue'
import { createCmpEngine } from '@/utils'
import store from '@/store'

export const openActivateCode = createCmpEngine(ActivateCode)

export const openActivateCodeWithGetShopInfo = function () {
    openActivateCode({
        callback: () => {
            store.dispatch('shop/getAndSetShopInfo')
        }
    })
}
